import { createFileRoute } from '@tanstack/react-router';

import { FindLocation } from 'features/get-started/FindLocation';

export const Route = createFileRoute('/_authenticated/get-started/_get-started/find-location/')({
  component: FindLocationRoute
});

function FindLocationRoute() {
  return <FindLocation />;
}
